import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

const BACKDROPS = {
  dark: {
    poster: "/media/public-atmosphere-dark.jpg",
    video: "/media/public-atmosphere-dark.mp4",
  },
  light: {
    poster: "/media/public-atmosphere-light.jpg",
    video: "/media/public-atmosphere-light.mp4",
  },
};

export default function PublicBackdrop({ mode, opacity = 0.08 }) {
  const theme = useTheme();
  const activeMode = mode || theme.palette.mode;
  const backdrop = BACKDROPS[activeMode] || BACKDROPS.light;
  const backdropOpacity =
    backdrop === BACKDROPS.light ? 0.28 : Math.min(Number(opacity) || 0, 0.18);

  return (
    <Box
      component="video"
      src={backdrop.video}
      poster={backdrop.poster}
      autoPlay
      loop
      muted
      playsInline
      preload="metadata"
      alt=""
      aria-hidden="true"
      sx={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        opacity: backdropOpacity,
        pointerEvents: "none",
        zIndex: 0,
      }}
    />
  );
}
